<script setup lang="ts">
import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from 'reka-ui'

defineProps<{
  theme: 'moss' | 'blurple'
  size: 'thick' | 'thin'
}>()

const controls = inject(diKeys.mediaControls)

const model = computed({
  get: () => [controls?.currentTime.value ?? 0],
  set: (sliderValues: (number | undefined)[]) => {
    const value = sliderValues[0]
    if (controls && typeof value === 'number') {
      controls.currentTime.value = value
    }
  },
})
</script>

<template>
  <SliderRoot v-model="model" :max="controls?.duration?.value" class="w-full self-stretch cursor-pointer relative flex items-center select-none touch-none">
    <SliderTrack
      class="relative grow rounded-full"
      :class="{
        'bg-white': theme === 'moss',
        'bg-blurple-400': theme === 'blurple',
        'h-px': size === 'thin',
        'h-[2px]': size === 'thick',
      }"
    >
      <SliderRange
        class="absolute h-full"
        :class="{
          'bg-moss-200': theme === 'moss',
          'bg-blurple-500': theme === 'blurple',
        }"
      />
    </SliderTrack>
    <SliderThumb
      class="rounded-full"
      :class="{
        'bg-moss-200': theme === 'moss',
        'bg-blurple-500': theme === 'blurple',
        'size-[11px]': size === 'thin',
        'size-[14px]': size === 'thick',
      }"
    />
  </SliderRoot>
</template>
